import { useState } from 'react';
import PropTypes from 'prop-types';
import Icon, { Icons } from 'components/Icon';
import { Alert, ErrorMsg } from './index.view';
import Grid from '@material-ui/core/Grid';

export const InputErrorMessage = ({ msg, title = 'Failed', openAlert, onClose }) => {
  const [open, setOpen] = useState(openAlert);

  if (!msg) return null;

  return (
    open && (
      <Grid item xs={12}>
        <Alert
          onClose={() => {
            onClose ? onClose() : setOpen(false);
          }}
          icon={<Icon name={Icons.Error} />}
        >
          <span>
            <strong>{title}</strong>
            <br />
            <ErrorMsg>{msg}</ErrorMsg>
          </span>
        </Alert>
      </Grid>
    )
  );
};
InputErrorMessage.propTypes = {
  msg: PropTypes.string,
  title: PropTypes.string,
  openAlert: PropTypes.bool,
  onClose: PropTypes.func,
};
